import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { Producto } from 'src/app/models/generic/Producto';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ProductosService } from '../../services/productos.service';
import { ProductosResumen } from '../../models/generic/ProductosResumen';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { TopAfiliadosPortafolioResumen_DTO } from 'src/app/models/generic/TopAfiliadosPortafolioResumen';
import { ApexAxisChartSeries, ApexChart, ChartComponent, ApexDataLabels, ApexXAxis, ApexPlotOptions, ApexTitleSubtitle } from "ng-apexcharts";
import { DecimalPipe } from '@angular/common';

export type ChartOptions = {
  series: number[];
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[],
  stroke: ApexStroke,
  title: ApexTitleSubtitle,
  subtitle: ApexTitleSubtitle,
  tooltip: ApexTooltip,
  responsive: ApexResponsive[],
  labels: string[],
  fill: ApexFill,
  states: ApexStates,
  theme: ApexTheme
};

@Component({
  selector: 'globalafiliadosporfatolio',
  templateUrl: './globalafiliadosporfatolio.component.html',
  styleUrls: ['./globalafiliadosporfatolio.component.scss']
})
export class GlobalafiliadosporfatolioComponent implements OnInit{
  mostrarCargando: boolean = false;
  ListaMostrar: TopAfiliadosPortafolioResumen_DTO[] = [];
  CANTIDAD_VISUALIZACION: number = 5;
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  listaColores: any[] = [
    {orden: 1, valor: 2005, color: 'rgb(240, 100, 100)'}
    ,{orden: 2, valor: 2010, color: 'rgb(130, 190, 255)'}
    ,{orden: 3, valor: 2015, color: 'rgb(212, 151, 69)'}
    ,{orden: 4, valor: 2020, color: 'rgb(140, 220, 120)'}
    ,{orden: 5, valor: 2025, color: 'rgb(190, 130, 255)'}
  ];

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {
      this.RecargarGrafica();
    }

  ngOnInit() {
    if (this.autenticacionService.EstaAutenticado()) {
      this.cargarResumen();

      this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
        if (cambiarResumen) {
          this.cargarResumen();
        }
      });
    }
  }

  cargarResumen() {
    this.mostrarCargando = true;
    
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    this.productosService.CargarTopAfiliadosPortafolioResumen(parametrosConsulta.value).subscribe((resp: TopAfiliadosPortafolioResumen_DTO[]) => {
      this.productosService.ListaTopAfiliadosPortafolioResumen = resp;
      this.ListaMostrar = resp;
      this.RecargarGrafica();
      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  RecargarGrafica() {
    let listData: number [] = [];
    let listLabels: string [] = [];
    let _Pipe = new DecimalPipe("en-US");
    
    if (this.utilitariosService.VerificarContieneDatos(this.ListaMostrar)) {
      for (let index = 0; index < this.ListaMostrar.length; index++) {
        listData.push(this.ListaMostrar[index].porcentaje);
        listLabels.push(`${_Pipe.transform(this.ListaMostrar[index].porcentajeMostrar, '1.1-1')}%-${this.ListaMostrar[index].producto}`);
      }
    }

    this.chartOptions = {
      series: listData,
      chart: {
      type: 'donut',
      dropShadow: {
        enabled: true,
        color: '#111',
        top: -1,
        left: 3,
        blur: 3,
        opacity: 0.2
      }
    },
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: false
            }
          }
        }
      }
    },
    labels: listLabels,
    dataLabels: {
      dropShadow: {
        blur: 3,
        opacity: 0.8
      }
    },
    legend: {
      show: false
    },
    title: {
      text: ""
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          show: false,
          position: 'bottom'
        }
      }
    }]
    };
  }
}
